import { ArticleCategory } from './articleCategories';

export interface Article {
  id: string;
  title: string;
  slug: string;
  summary: string; // Short description for previews
  description: string; // Longer description for SEO
  content?: React.ReactNode; // Optional content to be used directly
  date: string;
  readTime: string;
  category: ArticleCategory;
  image: string; // Path to local image
  featured?: boolean;
  relatedProducts?: string[]; // Product pages this article relates to
  relatedArticles?: string[]; // Related article IDs
  authorId?: string; 
  imageUrl?: string; 
  isFeatured?: boolean;
  keywords?: string[];
  thumbnailUrl?: string;
}

const articles: Article[] = [
  {
    id: "ulosoton-abc",
    title: "Ulosoton ABC - Kaikki mitä sinun tulee tietää ulosotosta",
    slug: "ulosoton-abc-kaikki-mita-sinun-tulee-tietaa-ulosotosta",
    summary: "Tässä kattavassa oppaassa käymme läpi, mitä ulosotto tarkoittaa, miten prosessi etenee ja mitä vaihtoehtoja velallisella on. Opas auttaa sinua ymmärtämään oikeutesi ja selviytymään haastavasta tilanteen.",
    description: "Ulosotto voi olla pelottava ja monimutkainen prosessi. Tämä opas selittää selkeästi ulosoton perusteet, prosessin vaiheet, velallisen oikeudet ja vaihtoehdot sekä tarjoaa konkreettisia neuvoja ulosottotilanteessa.",
    date: "2025-04-05",
    readTime: "10 min",
    category: "lainaoppaat",
    image: "/lovable-uploads/a462fcc8-fd52-4832-9cc4-6ee763d29736.png",
    featured: true,
    relatedProducts: ["yhdistelylaina", "kulutusluotto"],
    relatedArticles: ["lainan-ottamisen-opas-2025", "yhdistelylaina-opas", "kulutusluottojen-vertailu-saasta-korkokuluissa"]
  },
  {
    id: "kulutusluotto-vertailu",
    title: "Kulutusluottojen vertailu - Säästä korkokuluissa",
    slug: "kulutusluottojen-vertailu-saasta-korkokuluissa",
    summary: "Kulutusluottojen korot ja ehdot vaihtelevat paljon. Tässä artikkelissa vertailemme eri kulutusluottoja ja kerromme, miten voit säästät jopa satoja euroja korkokuluissa.",
    description: "Kulutusluottojen vertailu kannattaa aina. Lue tästä artikkelista, miten vertailet kulutusluottoja tehokkaasti ja säästät jopa satoja euroja korkokuluissa.",
    date: "2025-01-25",
    readTime: "7 min",
    category: "kulutusluotot",
    image: "/lovable-uploads/1c9feb20-4f8f-47cc-a973-32b2372e8f1b.png",
    featured: false,
    relatedProducts: ["kulutusluotto", "yhdistelylaina"],
    relatedArticles: ["lainan-ottamisen-opas-2025", "yhdistelylaina-opas", "oikea-laina-eri-tilanteisiin-2025"]
  },
  {
    id: "lainojen-vertailu",
    title: "Lainojen vertailu - Näin löydät parhaan lainan",
    slug: "lainojen-vertailu-nain-loydat-parhaan-lainan",
    summary: "Oletko etsimässä edullisinta lainaa? Tämä kattava opas auttaa sinua vertailemaan eri lainatarjouksia ja löytämään juuri sinulle sopivimman vaihtoehdon.",
    description: "Tässä kattavassa oppaassa kerromme, miten vertailet eri lainatarjouksia tehokkaasti ja löydät juuri sinulle sopivimman lainavaihtoehdon edullisimmalla korolla.",
    date: "2025-02-05",
    readTime: "8 min",
    category: "lainaoppaat",
    image: "/lovable-uploads/70703354-cc59-4371-b485-113a9ad004b4.png",
    featured: false,
    relatedProducts: ["kulutusluotto", "asuntolaina", "autolaina"],
    relatedArticles: ["kulutusluotto-vertailu", "lainan-ottamisen-opas-2025", "oikea-laina-eri-tilanteisiin-2025"]
  },
  
  // 2025 Articles
  {
    id: "vastuullinen-lainaaminen-2025",
    title: "Vastuullinen lainaaminen – näin teet kestäviä rahoituspäätöksiä",
    slug: "vastuullinen-lainaaminen-nain-teet-kestavia-rahoituspaatoksia",
    summary: "Vinkit taloudellisesti ja ekologisesti kestävään lainaamiseen nykymarkkinoilla.",
    description: "Tämä artikkeli auttaa sinua tekemään kestäviä rahoituspäätöksiä, jotka huomioivat sekä taloudelliset että ekologiset näkökulmat. Käymme läpi vastuullisen lainaamisen periaatteet ja konkreettiset vinkit.",
    date: "2025-04-04",
    readTime: "8 min",
    category: "vastuullisuus",
    image: "/lovable-uploads/beb41448-7d18-4b2d-b972-626967d769fe.png",
    featured: true,
    relatedProducts: ["vihreä-laina", "asuntolaina", "yhdistelylaina"],
    relatedArticles: ["inflaation-hidastuminen-2024", "lainan-ottamisen-opas-2025", "yhdistelylaina-opas"]
  },
  {
    id: "lainan-ottamisen-opas-2025",
    title: "Lainan ottamisen opas 2025 – Kaikki mitä sinun tulisi tietää",
    slug: "lainan-ottamisen-opas-2025",
    summary: "Kattava yleisopas lainan prosessista, kilpailutuksesta ja parhaiden tarjousten hyödyntämisestä vuonna 2025.",
    description: "Tämä opas auttaa sinua ymmärtämään lainan ottamisen prosessia, miten kilpailuttaa lainatarjouksia ja miten hyödyntää parhaita tarjouksia. Käymme läpi askel askeleelta lainan hakemisen ja vertailun vuonna 2025.",
    date: "2025-01-05",
    readTime: "5 min",
    category: "lainaoppaat",
    image: "/lovable-uploads/a964d1b0-995d-4cf2-8c86-642d277b43aa.png",
    featured: true,
    relatedProducts: ["kulutusluotto", "yhdistelylaina", "asuntolaina"],
    relatedArticles: ["oikea-laina-eri-tilanteisiin-2025", "inflaation-hidastuminen-2024", "korot-kokonaiskustannukset", "yrittajan-rahoitusopas-2025"]
  },
  {
    id: "oikea-laina-eri-tilanteisiin-2025",
    title: "Miten valita oikea laina eri tilanteisiin 2025?",
    slug: "miten-valita-oikea-laina-eri-tilanteisiin-2025",
    summary: "Käytännönläheinen opas eri lainatyyppien valintaan ja vertailuun eri elämäntilanteissa uudelle vuodelle.",
    description: "Tämä artikkeli auttaa valitsemaan sopivan lainatyypin erilaisiin elämäntilanteisiin. Käymme läpi eri lainatyypit ja niiden soveltuvuuden esimerkiksi asunnon ostoon, auton hankintaan, remontointiin ja yllättäviin menoihin.",
    date: "2025-01-20",
    readTime: "9 min",
    category: "lainaoppaat",
    image: "/lovable-uploads/6847fe72-a676-42fb-b372-8662eb543a7f.png",
    featured: true,
    relatedProducts: ["kulutusluotto", "asuntolaina", "autolaina"],
    relatedArticles: ["lainan-ottamisen-opas-2025", "inflaation-hidastuminen-2024", "yhdistelylaina-opas", "yrittajan-rahoitusopas-2025"]
  },
  {
    id: "yrittajan-rahoitusopas-2025",
    title: "Yrittäjän rahoitusopas 2025 – näin haet ja saat yrityslainaa",
    slug: "yrittajan-rahoitusopas-2025-nain-haet-ja-saat-yrityslainaa",
    summary: "Käytännönläheinen opas yrityslainan hakemiseen ja rahoituksen turvaamiseen vuodelle 2025.",
    description: "Yrityslainan hakeminen voi olla monimutkainen prosessi. Tässä oppaassa käymme läpi, mitä yrityslainan hakemisessa tulee huomioida vuonna 2025 ja annamme käytännön vinkkejä hakemuksen tekemiseen ja rahoituksen saamiseen.",
    date: "2025-01-15",
    readTime: "10 min",
    category: "yrityslainat",
    image: "/lovable-uploads/eb5bcb87-34d8-4b2e-95c9-4f926150c2b4.png",
    featured: true,
    relatedProducts: ["yrityslaina"],
    relatedArticles: ["lainan-ottamisen-opas-2025", "oikea-laina-eri-tilanteisiin-2025", "pienyrittajan-rahoitusopas-2025"]
  },
  {
    id: "asuntomarkkinat-ennuste-2025",
    title: "Asuntomarkkinoiden ennuste 2025 – kannattaako nyt ostaa vai myydä?",
    slug: "asuntomarkkinoiden-ennuste-2025-kannattaako-nyt-ostaa-vai-myyda",
    summary: "Katsaus asuntomarkkinoiden tilanteeseen ja ohjeita asunnon ostajalle ja myyjälle tulevalle vuodelle.",
    description: "Millaisessa tilanteessa asuntomarkkinat ovat vuonna 2025? Tässä artikkelissa analysoimme asuntomarkkinoiden nykytilaa ja tulevaisuuden näkymiä sekä annamme ohjeita sekä asunnon ostajalle että myyjälle.",
    date: "2025-01-10",
    readTime: "9 min",
    category: "asuntolainat",
    image: "/lovable-uploads/1a2db37f-dfa0-4427-a0f9-f4dbbd325274.png",
    featured: true,
    relatedProducts: ["asuntolaina"],
    relatedArticles: ["lainan-ottamisen-opas-2025", "korot-kokonaiskustannukset", "korkojen-nousu-inflaatio"]
  },
  {
    id: "pienyrittajan-rahoitusopas-2025",
    title: "Pienyrittäjän rahoitusopas 2025 – parhaat rahoitusvaihtoehdot eri tilanteisiin",
    slug: "pienyrittajan-rahoitusopas-2025-parhaat-rahoitusvaihtoehdot-eri-tilanteisiin",
    summary: "Kattava vertailu pienyrityksille tarjottavista rahoitusratkaisuista uudelle vuodelle.",
    description: "Pienyrittäjille on tarjolla monenlaisia rahoitusvaihtoehdot. Tässä oppaassa vertailemme eri rahoitusmuotoja ja autamme löytämään parhaan vaihtoehdon erilaisiin yrityksen tarpeisiin.",
    date: "2025-01-05",
    readTime: "11 min",
    category: "yrityslainat",
    image: "/lovable-uploads/71b5bbd9-ace3-4241-8e61-6f74742c0663.png",
    featured: true,
    relatedProducts: ["yrityslaina", "käyttöpääomalaina"],
    relatedArticles: ["yrittajan-rahoitusopas-2025"]
  },
  {
    id: "lomakohteet-2025",
    title: "Suosituimmat lomakohteet 2025 - Kotimaassa ja ulkomailla",
    slug: "suosituimmat-lomakohteet-2025",
    summary: "Kokosimme yhteen tulevaisuuden suosituimmat lomakohteet vuodelle 2025. Tutustu niin kotimaan kauneimpiin kohteisiin kuin ulkomaan uusiin nouseviin matkailukohteisiin.",
    description: "Suunnittelemassa unelmiesi lomaa vuodelle 2025? Tutustu suosituimpiin lomakohteisiin niin Suomessa kuin ulkomaillakin ja saa vinkkejä loman rahoittamiseen.",
    date: "2025-04-01",
    readTime: "10 min",
    category: "kulutusluotot",
    image: "/lovable-uploads/5830f45f-5c08-4e8c-90f2-598da9e5d6f1.png",
    featured: true,
    relatedProducts: ["kulutusluotto", "lomalaina"],
    relatedArticles: ["hauska-lomalaina", "venelainaopas-2025"]
  },
  {
    id: "yhdistelylaina-opas",
    title: "Yhdistelylaina-opas lainojen yhdistämiseen",
    slug: "yhdistelylaina-opas-lainojen-yhdistamiseen",
    summary: "Kattava opas yhdistelylainaan: miten yhdistää useat lainat yhdeksi edullisemmaksi kokonaisuudeksi, vinkit kilpailuttamiseen ja konkreettinen säästölaskelma.",
    description: "Tämä opas auttaa sinua ymmärtämään, miten voit yhdistää useat erilliset lainat yhdeksi edullisemmaksi yhdistelylainaksi. Käymme läpi yhdistelylainan hyödyt, hakuprosessin ja annamme konkreettisia vinkkejä lainan kilpailuttamiseen ja säästöjen maksimointiin.",
    date: "2025-02-15",
    readTime: "11 min",
    category: "lainaoppaat",
    image: "/lovable-uploads/e3855dbd-eab1-4937-8f61-3ebe4e0c3213.png",
    featured: true,
    relatedProducts: ["yhdistelylaina", "kulutusluotto"],
    relatedArticles: ["lainan-ottamisen-opas-2025", "oikea-laina-eri-tilanteisiin-2025", "kulutusluotto-vertailu"]
  },
  {
    id: "caravan-matkailu-suomessa-2025",
    title: "Caravan-matkailu Suomessa 2025 - Kattava opas",
    slug: "caravan-matkailu-suomessa-2025",
    summary: "Tutustu caravan-matkailun mahdollisuuksiin Suomessa. Parhaat kohteet, vinkit aloittelijoille ja rahoitusmahdollisuudet.",
    description: "Caravan-matkailu on yhä suositumpi tapa tutustua Suomen upeisiin maisemiin ja kokea ainutlaatuisia elämyksiä. Tässä kattavassa oppaassa käymme läpi kaiken mitä sinun tarvitsee tietää aloittaessasi caravan-harrastuksen.",
    date: "2025-05-10",
    readTime: "9 min",
    category: "kulutusluotot",
    image: "/lovable-uploads/632c70c3-da29-4b83-971f-24c4bc194bf8.png",
    featured: true,
    relatedProducts: ["caravanrahoitus", "kulutusluotto"],
    relatedArticles: ["venelainaopas-2025", "lomakohteet-2025", "hauska-lomalaina"]
  },
  
  // 2024 Articles (keep some from the previous year for history)
  {
    id: "vastuullinen-lainaaminen",
    title: "Vastuullinen lainaaminen – näin teet kestäviä rahoituspäätöksiä",
    slug: "vastuullinen-lainaaminen-nain-teet-kestavia-rahoituspaatoksia",
    summary: "Opas vastuulliseen ja ekologisesti kestävään lainaamiseen.",
    description: "Vastuullinen lainaaminen huomioi sekä taloudellisen että ekologisen kestävyyden. Tässä artikkelissa kerromme, miten voit tehdä vastuullisia rahoituspäätöksiä ja edistää kestävää kehitystä lainaamisen kautta.",
    date: "2024-05-28",
    readTime: "7 min",
    category: "vastuullisuus",
    image: "/lovable-uploads/beb41448-7d18-4b2d-b972-626967d769fe.png",
    relatedProducts: ["vihreä-laina", "asuntolaina"],
  },
  {
    id: "inflaation-hidastuminen-2024",
    title: "Miten inflaation hidastuminen vaikutti lainojen korkoihin 2024?",
    slug: "miten-inflaation-hidastuminen-vaikutti-lainojen-korkoihin-2024",
    summary: "Analyysi siitä, miten inflaation trendit vaikuttavat korkotasoihin ja lainakuluihin.",
    description: "Inflaatio oli korkealla, mutta hidastui merkittävästi. Tässä artikkelissa analysoimme, miten inflaation hidastuminen vaikutti lainojen korkoihin ja mitä se tarkoitti lainanottajille vuonna 2024.",
    date: "2024-12-12",
    readTime: "7 min",
    category: "korot",
    image: "/lovable-uploads/1c9feb20-4f8f-47cc-a973-32b2372e8f1b.png",
    relatedProducts: ["asuntolaina", "yhdistelylaina"],
    relatedArticles: ["korot-kokonaiskustannukset", "korkojen-nousu-inflaatio", "koron-nousun-taittuminen"]
  },
  
  {
    id: "korot-kokonaiskustannukset",
    title: "Näin korot vaikuttavat lainan kokonaiskustannuksiin",
    slug: "nain-korot-vaikuttavat-lainan-kokonaiskustannuksiin",
    summary: "Perusteellinen katsaus koron merkitykseen ja vaikutukseen laina-ajan kokonaiskustannuksiin.",
    description: "Korot vaikuttavat merkittävästi lainan kokonaiskustannuksiin. Tässä artikkelissa käymme läpi korkojen laskentaperiaatteet ja näytämme konkreettisilla esimerkeillä, miten pienikin korkoero vaikuttaa lainan kokonaishintaan.",
    date: "2023-03-22",
    readTime: "8 min",
    category: "korot",
    image: "/lovable-uploads/886a5105-052e-4546-9ba2-b653380a7c92.png",
    relatedProducts: ["asuntolaina", "autolaina"],
  },
  {
    id: "hauska-lomalaina",
    title: "Hauska lomalaina – Rahoita unelmalomasi Suomen 5 parhaaseen luontokohteeseen",
    slug: "hauska-lomalaina-rahoita-unelmalomasi-suomen-parhaisiin-luontokohteisiin",
    summary: "Suunnitteletko kesälomaa? Katso 5 parasta suomalaista luontokohdetta ja miten rahoittaa lomasi järkevästi.",
    description: "Suomen kauneimmat luontokohteet ovat täydellinen kesälomakohde. Tässä oppaassa esittelemme 5 parasta suomalaista uimarantaa ja patikointireittiä sekä järkevät rahoitusvaihtoehdot unelmalomallesi.",
    date: "2023-05-25",
    readTime: "7 min",
    category: "kulutusluotot",
    image: "/lovable-uploads/6b3cf9d5-ca4a-4e34-acf9-dc4dc45faf59.png",
    featured: true,
    relatedProducts: ["kulutusluotto", "joustoluotto"],
    relatedArticles: ["yhdistelylaina-opas", "lainan-ottamisen-opas-2025", "lomakohteet-2025"]
  },
  {
    id: "koron-nousun-taittuminen",
    title: "Koron nousun taittuminen – mitä lainanottajan tulisi nyt tietää?",
    slug: "koron-nousun-taittuminen-mita-lainanottajan-tulisi-tietaa",
    summary: "Vinkit lainanottajille korkojen muutosten aikana.",
    description: "Korkojen nousu näyttää taittuvan, mutta mitä lainanottajan tulisi huomioida tässä tilanteessa? Artikkelissa käydään läpi korkomarkkinoiden nykyistä tilannetta ja annetaan vinkkejä lainanottajille.",
    date: "2023-09-28",
    readTime: "7 min",
    category: "korot",
    image: "https://images.unsplash.com/photo-1518005020951-eccb494ad742?q=80&w=1740&auto=format&fit=crop",
    relatedProducts: ["asuntolaina", "yhdistelylaina"],
    relatedArticles: ["korkojen-nousu-inflaatio", "inflaation-hidastuminen-2024", "korot-kokonaiskustannukset"]
  },
  {
    id: "korkojen-nousu-inflaatio",
    title: "Korkojen nousu ja inflaatio – näin suojaat talouttasi",
    slug: "korkojen-nousu-ja-inflaatio",
    summary: "Käytännöllisiä neuvoja talouden turvaamiseen korkojen noustessa ja inflaation kiihtyessä.",
    description: "Korkojen nousu ja inflaatio luovat haasteita monille kotitalouksille. Tässä artikkelissa annamme käytännön neuvoja, miten voit suojata talouttasi näiden taloudellisten muutosten keskellä.",
    date: "2022-08-12",
    readTime: "9 min",
    category: "korot",
    image: "/lovable-uploads/70703354-cc59-4371-b485-113a9ad004b4.png",
    featured: false,
    relatedProducts: ["asuntolaina", "yhdistelylaina"],
    relatedArticles: ["koron-nousun-taittuminen", "inflaation-hidastuminen-2024", "korot-kokonaiskustannukset"]
  },
  {
    id: "venelainaopas-2025",
    title: "Venelainaopas - Näin rahoitat unelmiesi veneen",
    slug: "venelainaopas-nain-rahoitat-unelmiesi-veneen",
    summary: "Veneen hankintaan on tarjolla useita erilaisia rahoitusvaihtoehdot. Tämä opas auttaa sinua valitsemaan sopivimman ja edullisimman rahoitustavan.",
    description: "Veneen hankintaan on tarjolla useita erilaisia rahoitusvaihtoehdot. Tämä opas auttaa sinua valitsemaan sopivimman ja edullisimman rahoitustavan.",
    category: "kulutusluotot",
    date: "2025-03-15",
    readTime: "8 min",
    authorId: "finance-expert",
    image: "/lovable-uploads/5bf745f2-d3ce-4a35-8963-ae226573d447.png",
    isFeatured: false,
    keywords: ["venelaina", "venerahoitus", "vene", "rahoitus", "osamaksu", "pankkilaina"]
  },
  
  // Lisätään puuttuvat artikkelit tai päivitetään artikkelien tiedot
  {
    id: "autolaina-ohjeet",
    title: "Autolaina ohjeet - Näin rahoitat autonostosi järkevästi",
    slug: "autolaina-ohjeet",
    summary: "Kattava opas autolainan hakemiseen, vertailuun ja rahan säästämiseen autorahoituksessa.",
    description: "Kattava opas autolainan hakemiseen, vertailuun ja rahan säästämiseen autorahoituksessa. Katso eri vaihtoehdot ja vertaile niitä.",
    date: "2025-02-10",
    readTime: "9 min",
    category: "lainaoppaat",
    image: "/lovable-uploads/5b3139b8-84b2-446c-b5e7-c155cb8540d7.png",
    featured: false,
    relatedProducts: ["autolaina"],
    relatedArticles: ["lainan-ottamisen-opas-2025", "oikea-laina-eri-tilanteisiin-2025"]
  }
];

// Helper functions for working with articles
export const getArticleById = (id: string): Article | undefined => {
  return articles.find(article => article.id === id);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find(article => article.slug === slug);
};

export const getArticlesByCategory = (category: ArticleCategory | 'all'): Article[] => {
  if (category === 'all') return articles;
  return articles.filter(article => article.category === category);
};

export const getFeaturedArticles = (limit: number = 3): Article[] => {
  return articles
    .filter(article => article.featured)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, limit);
};

export const getRecentArticles = (limit: number = 5): Article[] => {
  return [...articles]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, limit);
};

export const getRelatedArticles = (articleId: string, limit: number = 3): Article[] => {
  const article = getArticleById(articleId);
  if (!article || !article.relatedArticles || article.relatedArticles.length === 0) {
    // Return articles in same category if no related articles specified
    return articles
      .filter(a => a.id !== articleId && a.category === article?.category)
      .slice(0, limit);
  }
  
  return article.relatedArticles
    .map(id => getArticleById(id))
    .filter((article): article is Article => article !== undefined)
    .slice(0, limit);
};

export const getRelatedProductArticles = (productType: string, limit: number = 3): Article[] => {
  return articles
    .filter(article => article.relatedProducts?.includes(productType))
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, limit);
};

export const searchArticles = (query: string): Article[] => {
  const searchTerm = query.toLowerCase().trim();
  if (!searchTerm) return [];
  
  return articles.filter(article => {
    return (
      article.title.toLowerCase().includes(searchTerm) ||
      article.summary.toLowerCase().includes(searchTerm) ||
      article.description.toLowerCase().includes(searchTerm) ||
      article.category.toLowerCase().includes(searchTerm)
    );
  });
};

// Make sure all articles have the required properties
articles.forEach(article => {
  if (!article.summary) article.summary = article.description;
  if (!article.image) article.image = article.imageUrl || "/images/articles/default-article-image.jpg";
  if (!article.featured) article.featured = false;
});

// Debug: Log all articles during initialization to help troubleshoot
console.log("All articles loaded:", articles.map(a => ({id: a.id, slug: a.slug, title: a.title})));

export default articles;
